import { useContext, React, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import Loader from "../../../../components/Loader/Loader";
import TextArea from "../../../../components/TextAreaBorderComponent/TextArea";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import { RoleAddContext } from "../AddRoleView";
import "./addRoles.css";

const AddRoles = () => {
  const {
    num,
    name,
    handleRoleName,
    validatedName,
    rolesList,
    handleDescription,
    addRoleformValidation,
    newPermissionCategory,
    spinnerStatus,
    userPermissionList,
    successAlertMessage,
    successAlertShow,
    errorAlertShow,
    errorAlertMessage,
    setErrorAlertShow,
    statusValue,
    roleToLogin,
    buttonText,
    dataUserPermissionList,
    description,
    nameValidation,
    validateDescription,
  } = useContext(RoleAddContext);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={rolesList}>
          {ContentData.rolePermissions.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.rolePermissions.addRole}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container className="addRolesPage">
        <div className="pageTittles">{ContentData.rolePermissions.addRole}</div>
        <form onSubmit={addRoleformValidation}>
          <div className="basicContainer">
            <div className="viewAdminSection addAdminSection">
              <div>
                <Row>
                  <Col xl="3" lg="6" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.rolePermissions.roleName}</h4>
                        <InputComponent
                          placeholder={ContentData.rolePermissions.typeRole}
                          value={name}
                          onChange={handleRoleName}
                          handleBlur={nameValidation}
                        />
                        <p className="mb-0 error-msg">
                          {validatedName ? validatedName : ""}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xl="12" lg="12" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.rolePermissions.description}</h4>
                        <TextArea
                          value={description}
                          onChange={handleDescription}
                          placeholder={
                            ContentData.rolePermissions.typeDescription
                          }
                        />
                        <p className="mb-0 error-msg">
                          {validateDescription ? validateDescription : ""}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          <div className="basicContainerRoleData">
            <div className="subHead">
              {ContentData.rolePermissions.permissionHead}
            </div>

            {userPermissionList?.map((item, index) => {
              return (
                <div className="flexPermission">
                  <div className="roleNameChoose">
                    <span>{item.name}</span>
                  </div>
                  <div className="rolePermissions">
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="View"
                        check={item.view}
                        id={item._id + "1"}
                        handleCheck={() => {
                          newPermissionCategory(item._id, "view", item.view);
                        }}
                      />
                    </div>
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="Add"
                        check={item.add}
                        id={item._id + "2"}
                        handleCheck={() => {
                          newPermissionCategory(item._id, "add", item.add);
                        }}
                      />
                    </div>
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="Edit"
                        check={item.edit}
                        id={item._id + "3"}
                        handleCheck={() => {
                          newPermissionCategory(item._id, "edit", item.edit);
                        }}
                      />
                    </div>
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="Delete"
                        check={item.delete}
                        id={item._id + "4"}
                        handleCheck={() => {
                          newPermissionCategory(
                            item._id,
                            "delete",
                            item.delete
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="bottomButtons">
            <BorderButton
              value={ContentData.authPage.cancelText}
              onClick={() => rolesList()}
            />
            <ThemeButton
              value={ContentData.authPage.submitText}
              id="submitAddEditBtn"
              type="submit"
            />
          </div>
        </form>
      </Container>
      <PopupAlertError
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            roleToLogin();
            setErrorAlertShow(false);
          } else {
            setErrorAlertShow(false);
            document.getElementById("submitAddEditBtn").click();
          }
        }}
      />
      <SuccessPopupAlert
        show={successAlertShow}
        alertMessage={successAlertMessage}
        handleSubmit={() => rolesList()}
      />
    </div>
  );
};

export default AddRoles;
